import userEvent from '@testing-library/user-event';
import { waitFor, fireEvent, screen } from '@testing-library/preact';
import { expect } from 'chai';
import {
  getAllMenuItemsByRole,
  getLabel,
  getMenuItemByRole
} from '#UNSAFE_Menu/__tests__/menuTestsUtils';

export const getTestContextMenuForNoData = (renderedElement: HTMLElement) => async () => {
  await userEvent.tab();
  await userEvent.keyboard('[ENTER]');
  fireEvent.keyDown(renderedElement, { key: 'F10', shiftKey: true });
  const menu = screen.queryByRole('menu');
  expect(menu).to.be.null;
};

export const getTestContextMenuViaKeyboard =
  (renderedElement: HTMLElement, menuContext: any, type: string | undefined) => async () => {
    expect(renderedElement).not.null;
    await userEvent.tab();
    await userEvent.keyboard('[ENTER]');
    fireEvent.keyDown(renderedElement, { key: 'F10', shiftKey: true });

    const menu = getMenuItemByRole('menu');
    const menuItems = getAllMenuItemsByRole('menuitem');
    //With this we check context menu context was set correctly
    const menuItemGotByLabel = getLabel('MenuItem1');
    expect(menu).not.null;
    expect(menuItems.length).equals(3);
    expect(menuItemGotByLabel).not.null;

    await waitFor(() => {
      expect(menuContext).not.null;
    });
    await waitFor(() => {
      expect(type).equals('item');
    });
    if (menuContext.type === 'item') {
      await waitFor(() => {
        expect(menuContext?.data).not.null;
      });
    }
  };

export const getTestContextMenuViaMouse = (renderedElement: Element) => async () => {
  const firstElement = renderedElement as HTMLElement;

  fireEvent.contextMenu(firstElement, {
    clientX: 50,
    clientY: 50,
    currentTarget: firstElement
  });
  const menu = getMenuItemByRole('menu');
  const menuItems = getAllMenuItemsByRole('menuitem');
  //With this we check context menu context was set correctly
  const menuItemGotByLabel = getLabel('MenuItem1');

  expect(menu).not.null;
  expect(menuItems.length).equals(3);
  expect(menuItemGotByLabel).not.null;
};
